<template>
  <div class="add-box common-shadow">
    <vxe-table
      border="none"
      show-overflow
      class="table-style"
      :auto-resize="true"
      align="center"
      :data="tableData"
    >
      <vxe-table-column field="goodsType" title="货物类型" width="14%">
      </vxe-table-column>
      <vxe-table-column field="goodsName" title="货名" width="14%">
      </vxe-table-column>
      <vxe-table-column
        field="goodsUnit"
        title="单位"
        width="14%"
      ></vxe-table-column>
      <vxe-table-column
        field="goodsCounts"
        title="合同数量"
        width="14%"
      ></vxe-table-column>
      <vxe-table-column field="priceType" title="计费方式" width="14%">
        <template v-slot="{ row }">
          <span>{{ row.priceType | priceTypeMap }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="counts"
        title="装货数量"
        width="14%"
      ></vxe-table-column>
      <vxe-table-column field="realCount" title="结算数量"></vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
export default {
  props: {
    detailData: Object
  },
  watch: {
    detailData(val) {
      if (val) {
        this.tableData = [
          {
            goodsType: val.goodsType,
            goodsName: val.goodsName,
            goodsUnit: val.goodsUnit,
            goodsCounts: val.goodsCounts,
            priceType: val.priceType,
            counts: val.counts,
            realCount: val.realCount
          }
        ];
      }
    }
  },
  data() {
    return {
      tableData: [
        {
          goodsType: null,
          goodsName: null,
          goodsUnit: null,
          goodsCounts: null,
          priceType: null,
          counts: null,
          realCount: null
        }
      ]
    };
  }
};
</script>

<style>
</style>